import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { ManagerService } from '@app/_core/services/manager.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map } from 'rxjs';
import { AuditorService } from '@app/_core/services/auditor.service';
import { InteractionDetailsComponent } from '../../interactions/interaction-details/interaction-details.component';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
@Component({
  selector: 'app-livestatuses-audits',
  templateUrl: './livestatuses-audits.component.html',
  styleUrls: ['./livestatuses-audits.component.scss'],
})
export class LivestatusesAuditsComponent implements OnInit {
  @Input() interactionId: any;
  auditsList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];

  modalRef?: BsModalRef;
  //isAsc: boolean = false;
  selectedFilterByField: any = '';
  filterVal: any = '';
  isAudit: boolean = false;
  cols: any = [
    { name: 'SurveyID', label: 'Audit ID', type: 'numeric' },
    { name: 'InteractionID', label: 'Interaction ID', showFilter: false },
    { name: 'SurveyForm', label: 'Survey Form', showFilter: true },
    { name: 'AuditType', label: 'Audit Type', showFilter: false },
    { name: 'Status', label: 'Status', showFilter: true },
    { name: 'Auditor', label: 'Auditor', showFilter: true, format: 'name' },
    { name: 'Score', label: 'Score', showFilter: false },
    { name: 'Date', label: 'Date', type: 'date', showFilter: false },
  ];

  constructor(
    private utils: Utils,
    private managerService: ManagerService,
    private modalService: BsModalService,
    private securityService: SecurityService,
    private auditorService: AuditorService,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  ngOnInit(): void {
    console.log('calling loadAgentAudits');
    this.loadAgentAudits();
  }

  loadAgentAudits() {
    this.managerService
      .GetAgentAudits(this.interactionId)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetLiveStatuses');
          if (isValid) {
            this.auditsList = data.Response.Data.Data;
            this.filteredData = this.auditsList;
            this.dataToDisplay = this.auditsList;
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (col.filterVals) {
        } else {
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]))];
          const filterData: any = [];
          for (const val of unique) {
            filterData.push({ name: val, checked: false });
          }
          col.filterVals = filterData;
        }
      } else {
      }
    }
    this.showColumnFilterModal(colName);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(FilterDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    });
  }
  formatDateTime(dt: any, inclSeconds: any = 0, inclWeekDay: any = 0) {
    return (
      (inclWeekDay ? this.getDayOfWeek(dt) + ' ' : '') + this.formatDate(dt) + ' ' + this.formatTime(dt, inclSeconds)
    );
  }

  getDayOfWeek(dt: any) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dt.getDay()];
  }
  formatTime(dt: any, inclSeconds: any) {
    if (isNaN(dt)) return '0:00';

    let isPM = false,
      hour: any = new Date(dt).getHours(),
      min: any = new Date(dt).getMinutes(),
      seconds: any = new Date(dt).getSeconds();
    if (hour > 11) {
      isPM = true;
      if (hour > 12) hour = hour - 12;
    } else if (hour == 0) hour = 12;
    if (min < 10) min = '0' + min;
    if (seconds < 10) seconds = '0' + seconds;
    return hour + ':' + min + (inclSeconds ? ':' + seconds : '') + (isPM ? ' PM' : ' AM');
  }

  formatDate(dt: any) {
    return this.utils.formatDate(dt);
  }
  /*column level filter*/
  applyColumnFilters(list: any) {
    //apply column filter here and assign to dataTodisplay
    let records = list;
    for (const colData of this.cols) {
      const filterVals: any = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name);
          }
        }
        //filterVals
        records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
      }
    }
    return records;
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          if (entry[properties].toString() == search) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }
  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }
  onRowSelect(event: any) {
    console.log(event);
    this.isAudit = this.securityService.validateGrant('AuditAgents');
    if (this.isAudit) {
      const initialState = 
      {
        interactionId: event.data.InteractionID,
        liveStatusesAudit: true
      };
      const config: ModalOptions = 
      {
        backdrop: 'static',
        class: 'interactionDetails-Auditmenu',
        initialState,
      };
  
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
     }
    else if (!this.isAudit) 
      {
      this.auditorService.GetSurveysGroupedByDefinition(event.data.InteractionID)
        .subscribe((res: any) => {
          const list = res?.Response?.Data ?? [];
          const allSurveys = list.flatMap(d => d?.Surveys ?? []);
          const loggedUser = this.webStorageService.getItemFromSessionStorage('currentUser');
          const loggedEmail = loggedUser?.Email?.toLowerCase();
          const hasSubmittedSurvey = allSurveys.some(s =>
            s?.Status?.Name?.toLowerCase() === 'submitted'
          );
          const hasReviewerAccessSurvey = allSurveys.some(s => {
            const status = s?.Status?.Name?.toLowerCase();
            const reviewerEmail = s?.User?.Email?.toLowerCase();
            return (
              (status === 'inprogress' || status === 'in progress' || status === 'complete') &&
              reviewerEmail === loggedEmail
            );
          });
          const modalClass =
            hasSubmittedSurvey || hasReviewerAccessSurvey
              ? 'interactionDetails-Auditmenu'
              : 'interactionDetails-menu';
          const initialState = {
            interactionId: event.data.InteractionID,
            liveStatusesAudit: true
          };
    
          const config: ModalOptions = {
            backdrop: 'static',
            class: modalClass,
            initialState,
          };
          this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
        });
       }
       else 
       {
      const initialState = 
       {
        interactionId: event.data.InteractionID,
        liveStatusesAudit: true
       };
  
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-menu',
        initialState,
      };
  
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    }
  }

  // onRowSelect(event: any) {
  //   const initialState = {
  //     interactionId: event.data.InteractionID,
  //     liveStatusesAudit: true
  //   };
  //   const config: ModalOptions = {
  //     backdrop: 'static',
  //     class: 'interactionDetails-Auditmenu',
  //     initialState,
  //   };
  //   this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
  //   // this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  // }
}
